










































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Order } from '@/models/order';
import { Product } from '@/models/product';
import * as firebase from 'firebase';
import utility from '@/utility/utility';
import { APP_CONFIG } from '@/config/app-config';

@Component
export default class NewProduct extends Vue {
    private newProduct: any = {
        link_origin: '',
        image_origin: '',
        property: '',
        quantity: 1,
        price_origin: 0,
        comment: ''
    };
    private imageData: any = null;
    private uploadValue = 0;
    private hideImage = false;

    private onAddProduct() {
        this.$emit('eventAddProduct', this.newProduct);
        this.newProduct = {
            link_origin: '',
            image_origin: '',
            property: '',
            quantity: 1,
            price_origin: 0,
            comment: ''
        };
    }

    private chooseImage(item) {
        this.newProduct = item;
        this.newProduct.image_origin = '';
        (this.$refs.fileInput as any).click();
    }

    private previewImage(event) {
        this.uploadValue = 0;
        this.imageData = event.target.files[0];
        (this.$refs.fileInput as any).value = null;
        this.onUpload()
    }

    private onUpload() {
        const arrFileType = this.imageData.name.split('.');
        const storageRef=firebase.storage().ref(`${APP_CONFIG.settings.firebase_prefix}/${utility.randomString(35)}.${arrFileType[arrFileType.length - 1]}`).put(this.imageData);
        storageRef.on(`state_changed`, snapshot => {
                this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
            }, error => {
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: 'File ảnh chỉ được tối đa 1Mb!',
                });
            },
            () => {
                this.uploadValue=100;
                storageRef.snapshot.ref.getDownloadURL().then((url) => {
                    this.newProduct.image_origin =url;
                    this.hideImage = true;
                    this.$nextTick(() => this.hideImage = false);
                });
            }
        );
    }
}
